import { render, staticRenderFns } from "./MatchBrandDetail.vue?vue&type=template&id=d8082b7a&"
import script from "./MatchBrandDetail.vue?vue&type=script&lang=js&"
export * from "./MatchBrandDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports